<template>
  <div>
    <RadioGroup name="layout">
      <div
        v-for="item in layoutsList"
        :key="item.id"
        class="flex justify-between cursor-pointer hover:bg-grey-100 px-6 py-2 rounded"
        @click="click($event, item)"
      >
        <RadioField
          :name="item.label"
          :model-value="roomLayout"
          :val="item.id"
          :label="item.label"
        />
        <div class="flex justify-center items-center icon-wrapper">
          <TagIcon
            :icon="item.iconComponent"
            class="c-icon--accent-green"
          />
        </div>
      </div>
    </RadioGroup>
  </div>
</template>

<script>
import BoardroomLayoutIcon from '@tagvenue/icons/40/boardroom-layout.svg';
import CabaretLayoutIcon from '@tagvenue/icons/40/cabaret-layout.svg';
import ClassroomLayoutIcon from '@tagvenue/icons/40/classroom-layout.svg';
import DiningLayoutIcon from '@tagvenue/icons/40/dining-layout.svg';
import SittingLayoutIcon from '@tagvenue/icons/40/sitting.svg';
import StandingLayoutIcon from '@tagvenue/icons/40/standing-single.svg';
import TheatreLayoutIcon from '@tagvenue/icons/40/theatre-layout.svg';
import UShapedLayoutIcon from '@tagvenue/icons/40/u-shaped-layout.svg';
import { markRaw } from 'vue';

import TagIcon from '@/components/TagIcon.vue';
import RadioField from '@/components/Ui/Forms/RadioField.vue';
import RadioGroup from '@/components/Ui/Forms/RadioGroup.vue';

import layoutNames from './layoutNames.json';

export default {
  name: 'LayoutPopup',
  emits: ['change'],
  components: {
    RadioGroup,
    RadioField,
    TagIcon,
  },
  props: {
    roomLayout: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      layouts: [
        {
          id: this.$store.state.sittingLayoutKey,
          image: 'chair-grey.svg',
          label: layoutNames[`${this.$store.state.sittingLayoutKey}`],
          iconComponent: markRaw(SittingLayoutIcon),
        },
        {
          id: this.$store.state.standingLayoutKey,
          image: 'standing-grey.svg',
          label: layoutNames[`${this.$store.state.standingLayoutKey}`],
          iconComponent: markRaw(StandingLayoutIcon),
        },
        {
          id: 1,
          image: 'dining.svg',
          label: layoutNames['1'],
          iconComponent: markRaw(DiningLayoutIcon),
        },
        {
          id: 5,
          image: 'theatre.svg',
          label: layoutNames['5'],
          iconComponent: markRaw(TheatreLayoutIcon),
        },
        {
          id: 2,
          image: 'boardroom.svg',
          label: layoutNames['2'],
          iconComponent: markRaw(BoardroomLayoutIcon),
        },
        {
          id: 3,
          image: 'cabaret.svg',
          label: layoutNames['3'],
          iconComponent: markRaw(CabaretLayoutIcon),
        },
        {
          id: 6,
          image: 'u-shaped.svg',
          label: layoutNames['6'],
          iconComponent: markRaw(UShapedLayoutIcon),
        },
        {
          id: 4,
          image: 'classroom.svg',
          label: layoutNames['4'],
          iconComponent: markRaw(ClassroomLayoutIcon),
        },
      ],
    };
  },
  computed: {
    order() {
      if (this.$store.state.eventCategory === 'meeting') {
        return [this.$store.state.sittingLayoutKey, this.$store.state.standingLayoutKey, 2, 3, 4, 5, 6, 1];
      }
      if (this.$store.state.eventCategory === 'business') {
        return [this.$store.state.sittingLayoutKey, this.$store.state.standingLayoutKey, 5, 3, 1, 4, 2, 6];
      }
      if (this.$store.state.eventCategory === 'party') {
        return [this.$store.state.sittingLayoutKey, this.$store.state.standingLayoutKey, 1, 5, 2, 3, 6, 4];
      }
      if (this.$store.state.eventCategory === 'wedding') {
        return [this.$store.state.sittingLayoutKey, this.$store.state.standingLayoutKey, 1, 5, 2, 3, 6, 4];
      }
      // venue_type order
      return [this.$store.state.sittingLayoutKey, this.$store.state.standingLayoutKey, 1, 5, 3, 2, 4, 6];
    },
    layoutsList() {
      return [...this.layouts].sort((a, b) => this.order.indexOf(a.id) - this.order.indexOf(b.id));
    },
  },
  methods: {
    click(event, item) {
      if (event.target.tagName === 'INPUT') { // When input is wrapped in label, clicks on label trigger click on Input, doubling the event.
        return;
      }
      this.$emit('change', item.id);
    },
  },
};
</script>

<style lang="scss" scoped>

  .icon-wrapper {
    flex-basis: 25%;
  }
</style>
